import React from "react";
import { useTheme } from "@material-ui/core";
import SvgIcon from "@material-ui/core/SvgIcon";

export function ErrorIcon(props) {
  const theme = useTheme();
  return (
    <svg
      {...props}
      width="100"
      height="68"
      viewBox="0 0 100 68"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M22.5394 48.5372C14.2751 52.6841 7.55835 58.6212 3.125 65.698L6.64199 67.1875C10.7428 60.6414 16.9558 55.1496 24.6003 51.3137C32.2448 47.4778 41.0258 45.4458 49.9815 45.4402C58.9371 45.4347 67.7219 47.4559 75.3734 51.2823C83.0249 55.1088 89.2479 60.5929 93.3607 67.1338L96.875 65.64C92.4287 58.5687 85.7011 52.6399 77.4292 48.5033C69.1573 44.3666 59.6603 42.1815 49.9785 42.1875C40.2967 42.1935 30.8037 44.3903 22.5394 48.5372Z"
        fill={theme.palette.primary.main}
      />
      <circle cx="12.5" cy="12.5" r="12.5" fill={theme.palette.primary.main} />
      <circle cx="87.5" cy="12.5" r="12.5" fill={theme.palette.primary.main} />
    </svg>
  );
}

export function HappyIcon(props) {
  const theme = useTheme();
  return (
    <svg
      {...props}
      width="100"
      height="90"
      viewBox="0 0 100 90"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M22.4662 83.6503C14.1798 79.5034 7.44517 73.5663 3 66.4895L6.52637 65C10.6382 71.5461 16.8677 77.0379 24.5326 80.8738C32.1974 84.7097 41.0019 86.7417 49.9814 86.7473C58.961 86.7528 67.7692 84.7316 75.4411 80.9052C83.113 77.0787 89.3526 71.5946 93.4764 65.0537L97 66.5475C92.5418 73.6188 85.7963 79.5476 77.5024 83.6842C69.2084 87.8209 59.6861 90.006 49.9785 90C40.2708 89.994 30.7525 87.7972 22.4662 83.6503Z"
        fill={theme.palette.primary.main}
      />
      <circle cx="12.5" cy="12.5" r="12.5" fill={theme.palette.primary.main} />
      <circle cx="87.5" cy="12.5" r="12.5" fill={theme.palette.primary.main} />
    </svg>
  );
}

export function AppIcon({ size = 100 }) {
  const theme = useTheme();

  return (
    <svg
      viewBox="0 0 101 115"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size+14}
      // style={{ width: size, height: size + 14 }}
    >
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M24.25 14.1109L0 28.1199V57.4499V86.7798L7.75 91.1839C12.013 93.6068 23.099 99.9329 32.387 105.244C41.674 110.554 49.706 114.899 50.234 114.899C51.28 114.899 93.773 90.8158 98.25 87.6859L101 85.7628V56.4979C101 33.4769 100.728 27.2319 99.728 27.2319C99.028 27.2319 94.19 24.7299 88.978 21.6719C83.765 18.6139 77.925 15.2219 76 14.1339C74.075 13.0459 67.665 9.39785 61.756 6.02785C55.847 2.65685 50.447 -0.0551481 49.756 0.000851907C49.065 0.0568519 37.587 6.40585 24.25 14.1109ZM45.208 11.0409C43.398 12.1999 42.048 13.2619 42.208 13.4009C42.369 13.5399 44.314 14.5669 46.53 15.6839L50.56 17.7149L54.427 15.3819L58.293 13.0479L54.897 10.9769C50.658 8.39285 49.329 8.40185 45.208 11.0409ZM30.204 19.7099L27.909 21.4759L34.704 25.3419C38.442 27.4689 43.525 30.3179 46 31.6749L50.5 34.1409L61 27.9269C73.368 20.6079 72.831 21.0429 70.971 19.8359C67.28 17.4409 65.204 17.8119 57.79 22.1949L50.283 26.6339L42.542 22.2669C38.285 19.8639 34.284 17.9089 33.651 17.9209C33.018 17.9328 31.467 18.7379 30.204 19.7099ZM13.5 29.2599L7.5 32.5969L7.233 57.2049L6.965 81.8129L16.384 87.3559C21.564 90.4049 26.184 92.8958 26.651 92.8918C27.118 92.8888 28.766 92.0508 30.314 91.0298L33.128 89.1749L23.585 83.7868L14.042 78.3988L14.021 57.3649L14 36.3299L16.794 34.6799C19.494 33.0849 19.768 33.1319 25.044 36.1049C28.045 37.7959 32.862 40.5009 35.75 42.1149L41 45.0489V56.4319V67.8148L45.539 70.4748L50.079 73.1348L54.539 70.7689L59 68.4018V56.6939V44.9849L69.583 39.0359C80.092 33.1289 80.187 33.0989 83.077 34.7429L85.987 36.3989L85.973 57.3989L85.958 78.3988L76.415 83.7868L66.872 89.1749L69.686 91.0298C71.234 92.0508 72.872 92.8888 73.327 92.8918C73.783 92.8958 78.378 90.5368 83.54 87.6488L92.926 82.3988L92.963 57.7709C92.991 39.2189 92.692 32.9039 91.75 32.1699C91.063 31.6349 88.201 29.9259 85.39 28.3739L80.281 25.5509L65.216 34.2739L50.152 42.9969L40.326 37.2999C28.544 30.4699 20.317 25.8948 19.845 25.9109C19.655 25.9169 16.8 27.4249 13.5 29.2599ZM22 58.7109V73.8338L31.546 79.4509C40.777 84.8839 41.172 85.0158 43.546 83.4608C44.896 82.5768 46 81.4519 46 80.9619C46 80.4719 43.075 78.4349 39.5 76.4359L33 72.8008V63.0459C33 52.3599 33.332 53.0279 24.25 45.4629L22 43.5889V58.7109ZM72.742 48.1869L67.984 52.3989L67.992 62.4389L68 72.4779L61 76.2589C57.15 78.3379 54 80.4059 54 80.8539C54 81.3018 55.133 82.4109 56.517 83.3178C58.967 84.9229 59.287 84.8258 68.48 79.6828L77.926 74.3988L77.963 59.1489C77.983 50.7609 77.888 43.9159 77.75 43.9369C77.612 43.9589 75.359 45.8708 72.742 48.1869ZM42.193 92.8848C38.724 94.9718 35.649 96.9168 35.359 97.2068C35.069 97.4958 38.297 99.7418 42.533 102.197L50.234 106.66L57.255 102.513C61.117 100.233 64.224 97.9239 64.161 97.3829C64.023 96.2038 51.326 88.8578 49.663 88.9949C49.024 89.0469 45.662 90.7979 42.193 92.8848Z"
        fill={theme.palette.primary.main}
      />
    </svg>
  );
}

export function AppLogo(props) {
  return (
    <SvgIcon
      viewBox="0 0 87 100"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M24.1706 82.6087C24.568 82.6062 25.8416 81.6617 27.1589 80.7929L29.5535 79.2144L21.4328 74.6294L13.3121 70.0444L13.2942 52.1454L13.2764 34.2455L15.6539 32.8415C17.9515 31.4842 18.1847 31.5242 22.6743 34.0541C25.2281 35.493 29.3271 37.7949 31.7847 39.1683L36.2522 41.665V51.3515V61.0379L40.1147 63.3015L43.978 65.565L47.7733 63.5516L51.5694 61.5374V51.5744V41.6106L60.5751 36.5482C69.5178 31.5216 69.5987 31.4961 72.0579 32.8951L74.5342 34.3042L74.5223 52.1743L74.5095 70.0444L66.3888 74.6294L58.2682 79.2144L60.6628 80.7929C60.6628 80.7929 62.8892 82.7182 63.2764 82.7208L56.7546 86.6338C55.8851 86.199 45.0392 78.9446 43.624 79.0612C43.0803 79.1054 40.2194 80.5955 37.2674 82.3714C34.3154 84.1473 31.3492 86.387 31.1025 86.6338L24.1706 82.6087ZM20.084 66.1598V53.2908V40.4226L29.4446 45.4935V65.2808L34.9758 68.374C38.0179 70.0751 40.507 71.8085 40.507 72.2254C40.507 72.6424 39.5675 73.5997 38.4187 74.352C36.3986 75.6752 36.0624 75.5629 28.2073 70.9396L20.084 66.1598ZM59.2212 56.4632V45.4935L67.5249 40.7188C67.6423 40.7009 67.7231 46.5257 67.7061 53.6635L67.6746 66.6406L59.6365 71.1371C51.8137 75.5135 51.5413 75.5961 49.4565 74.2303C48.2788 73.4585 47.3146 72.5148 47.3146 72.1335C47.3146 71.7523 49.9952 69.9925 53.2713 68.2234L59.228 65.0059L59.2212 56.4632Z"
      />
      <path d="M33.7358 12.6087C33.8728 12.727 39.0969 15.6141 40.9826 16.5646L44.412 18.2929L47.7026 16.3076L53.7358 12.6087L59.8228 16.087L50.5644 22.1052L44.1763 25.8826L37.589 22.1665C33.9665 20.1216 27.7527 16.5544 27.2141 16.5646L33.7358 12.6087Z" />
      <path d="M21.5619 19.5652L30.9192 24.7832C34.1001 26.5932 38.4255 29.0175 40.5316 30.1723L44.3609 32.2707L53.296 26.9829L65.4749 19.5652L71.5619 23.0435L56.8836 32.3839L44.0648 39.8068L35.7033 34.9589C25.6773 29.1469 15.8766 23.0299 15.4749 23.0435L21.5619 19.5652Z" />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M86.6021 25L43.3013 0L0 25V75L43.3013 100L86.6021 75V25ZM81.3893 28.6957L43.736 6.95652L6.08276 28.6957V72.1739L43.736 93.913L81.3893 72.1739V28.6957Z"
      />
    </SvgIcon>
  );
}
